import axios from "axios";
import { AddressInput } from "./registerPages/addressPage";
import type {
  RegisterPostPayload,
  RegisterPostResponse,
} from "@qivia/schemas-office";

export type BusinessTypeForDB = "COMPANY" | "NON_PROFIT";

export type RegisterAPI = Omit<RegisterPostPayload, "address"> & {
  address: AddressInput;
};

export const registerCall = async (payload: RegisterAPI) => {
  const BACKEND_URL = import.meta.env["VITE_BACKEND_URL"] as string;
  return await axios.post<RegisterPostResponse>(
    `${BACKEND_URL}/office/register`,
    payload,
  );
};
